import React, { useEffect, useState } from 'react';
import {
    Row,
    Col,
    Input,
    Table,
    Button,
    Switch,
    Spin,
    message,
    Form,
    Modal
} from 'antd';
import notice from 'images/new_pop_ups/notice.svg';
import icon_processing from 'images/icon_processing.svg';

import axios from 'services/axios_config';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import parseCliboard from './pasteExcel';
import background_circle_green from 'images/background_circle_green.svg';
import icon_in_green_circle from 'images/icon_in_green_circle.svg';
import { getDataHeaderRowSet } from 'services/home';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import HeaderHome from 'components/header/HeaderHome';
import Column from './Upload/Columns';
import cloneDeep from 'lodash/cloneDeep';

import { createManualData } from 'services/project';

const ManualData = () => {
    let navigate = useNavigate();
    const [form] = Form.useForm();
    const { id } = useParams();

    const [IsSpinner, setIsSpinner] = useState(false);

    const [labels, setLabels] = useState([]);
    const [inputvalue, setInputvalue] = useState([]);

    const [tableRender, setTableRender] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [tableColumn, setTableColumn] = useState([]);

    const [fileName, setFileName] = useState('');
    const [headerMessage, setHeaderMessage] = useState('');
    const [clickNext, setClickNext] = useState(false);
    const [showEmptyTablePopup, setShowEmptyTablePopup] = useState(false);

    const handleChangeFileName = (e) => {
        setFileName(e.target.value);
    };

    useEffect(() => {
        if (clickNext) {
            formCheck();
        } else {
            setClickNext(true);
        }
        // }, [props.headerInputValue, props.rowValue]);
    }, []);

    const changeShowEmptyTablePopup = () => {
        setShowEmptyTablePopup(false);
    };

    const formCheck = (hasAny) => {
        let headerMessage = '';

        if (fileName == '') {
            // headerMessage = 'Please input your dataset name!';
            headerMessage = 'Please enter a name for your dataset.';
        }

        if (!hasAny) {
            setShowEmptyTablePopup(true);
        }

        setHeaderMessage(headerMessage);
        if (headerMessage !== '' || !hasAny) {
            form.validateFields();
            return false;
        } else {
            return true;
        }
    };

    const handlePaste = (index, elm, e, i) => {
        return parseCliboard(e);
    };

    const handlePaste1 = (index, elm, e, i) => {
        let newInput = inputvalue.map(({ ...item }, i) =>
            index === i
                ? {
                      ...item,
                      [elm]: e.target.value
                  }
                : item
        );

        setInputvalue(newInput);
    };

    const handelSendManualData = () => {
        let data = [];
        let items = cloneDeep(inputvalue);
        let hasAny = false;

        for (let n in items) {
            const item = { ...items[n] };
            for (let col in item) {
                let inputValue = document.querySelector('#IN' + n + col).value;
                if (hasAny == false && inputValue !== '') {
                    hasAny = true;
                }
                item[col] = inputValue;
            }

            let row = Object.values(item);
            data.push(Object.assign({}, row));
        }

        if (formCheck(hasAny)) {
            setIsSpinner(true);
            createManualData({
                name: fileName,
                json_data: JSON.stringify(data)
            }).then((res) => {
                if (res.status == 201) {
                    let file_id = res.data.file_id;
                    setTimeout(() => {
                        navigate(`/setheaderrow/${file_id}`);
                    }, 1000);
                }
            });
        }
    };

    const handleKeyDown = (index, elm, e, i) => {
        let row = parseInt(index);
        let col = parseInt(elm.substr(1));

        if (e.keyCode == '38') {
            // up arrow
            row = row != 0 ? row - 1 : row;
        } else if (e.keyCode == '40' || e.key === 'Enter') {
            // down arrow
            row = row != 100 ? row + 1 : row;
        } else if (e.keyCode == '37') {
            // left arrow
            col = col !== 1 ? col - 1 : col;
        } else if (e.keyCode == '39') {
            // right arrow
            col = col !== 10 ? col + 1 : col;
        }

        let nextInput = document.querySelector('#IN' + row + 'C' + col);
        nextInput.focus();
        // var val = nextInput.value; //store the value of the element
        // nextInput.value = ''; //clear the value of the element
        // nextInput.value = val;
    };

    useEffect(() => {
        let newRow = {};
        let newLabels = [];
        for (let c = 1; c < 11; c++) {
            newLabels.push(`C${c}`);
            newRow[`C${c}`] = '';
        }
        for (let c = 1; c < 101; c++) {
            inputvalue.push(newRow);
        }

        setLabels(newLabels);
        setInputvalue(inputvalue);
    }, []);

    return (
        <>
            <Row>
                <Col style={{ flex: '1 1 auto' }}>
                    <HeaderHome />
                </Col>
            </Row>

            <Row>
                <Col span={16}>
                    <Row id="set-header-row">
                        <div
                            className="final-view-table-manual"
                            style={{
                                width: '100%',
                                background: '#fff',
                                border: '3px solid #60091D',
                                height: 'calc(100vh - 112px)',
                                background: '#fff',
                                overflow: 'scroll'
                            }}
                        >
                            <div
                                style={{
                                    background: '#edebe9',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    position: 'sticky',
                                    left: 0,
                                    top: 0
                                }}
                            >
                                <div className="header-preview">
                                    MANUAL DATA INSERT
                                </div>
                            </div>
                            <table className="manual-data">
                                <tr className="text-center">
                                    <th></th>
                                    {labels.map((elm, ind) => {
                                        return (
                                            <th
                                                style={{
                                                    width: '150px'
                                                    // border: '1px solid #d4d4d4'
                                                }}
                                            >
                                                {elm}
                                            </th>
                                        );
                                    })}
                                </tr>
                                {inputvalue.map((res, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            {labels.map((elm, i) => {
                                                return (
                                                    <td
                                                        style={{
                                                            width: '80px',
                                                            minHeight: '30px',
                                                            border: '1px solid #d4d4d4',
                                                            borderRadius: '0px',
                                                            wordWrap:
                                                                'break-word'
                                                        }}
                                                    >
                                                        <input
                                                            id={`IN${index}${elm}`}
                                                            onInput={(e) => {
                                                                handlePaste1(
                                                                    index,
                                                                    elm,
                                                                    e,
                                                                    i
                                                                );
                                                            }}
                                                            onPaste={(e) => {
                                                                handlePaste(
                                                                    index,
                                                                    elm,
                                                                    e,
                                                                    i
                                                                );
                                                            }}
                                                            type="textbox"
                                                            onKeyDown={(e) => {
                                                                handleKeyDown(
                                                                    index,
                                                                    elm,
                                                                    e,
                                                                    i
                                                                );
                                                            }}

                                                            // className="text-center inputtextbox"
                                                        />
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    );
                                })}
                            </table>
                        </div>
                        <div></div>
                    </Row>
                </Col>
                <Col span={8}>
                    <Col className="select-data-right-side">
                        {/* <div className="icon-container">
                        <img
                            className="img-icon-container"
                            src={background_circle_green}
                        />
                        <img
                            className="icon-in-green-circle"
                            src={icon_in_green_circle}
                        />
                    </div> */}
                        <div>
                            <Row>
                                <Col>
                                    <p className="title-header">New Dataset</p>
                                </Col>
                            </Row>

                            <Row className="d-flex-flex-column">
                                <Col>
                                    <div
                                        className="p-desctiption"
                                        style={{ paddingTop: '30px' }}
                                    >
                                        Choose a name for the dataset that you
                                        are creating.
                                    </div>
                                    <p className="p-desctiption2">
                                        {'('}The dataset and the associated
                                        project will be added to your dashboard.
                                        After you submit, you will not be able
                                        to edit this data.
                                        {')'}
                                    </p>

                                    <div className="d-flex-flex-column">
                                        {/* <label>
                                            First Row {'('}Required{')'}
                                        </label> */}

                                        <Form
                                            // form={form}
                                            initialValues={{
                                                remember: true
                                            }}
                                        >
                                            <Form.Item
                                                label=""
                                                validateStatus={
                                                    headerMessage == ''
                                                        ? 'success'
                                                        : 'error'
                                                }
                                                help={headerMessage}
                                            >
                                                <Input
                                                    onChange={
                                                        handleChangeFileName
                                                    }
                                                    placeholder="Type name here"
                                                />
                                            </Form.Item>
                                        </Form>
                                    </div>

                                    <div
                                        className="p-desctiption"
                                        style={{ paddingTop: '10px' }}
                                    >
                                        Data input in this way is currently
                                        limited to:
                                    </div>
                                    <div
                                        className="p-desctiption"
                                        style={{ paddingTop: '20px' }}
                                    >
                                        10 columns<br></br>
                                        100 rows
                                    </div>
                                    <p
                                        className="p-desctiption2"
                                        style={{ paddingTop: '30px' }}
                                    >
                                        Data may be copied and pasted or input
                                        manually.
                                    </p>
                                </Col>
                            </Row>
                        </div>

                        <Row>
                            <Col
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    marginBottom: 21
                                }}
                                span={24}
                            >
                                <Button
                                    onClick={() => {
                                        handelSendManualData();
                                    }}
                                    className="blue-button"
                                    style={{
                                        // width: 250,
                                        minWidth: 150,
                                        maxWidth: 250,
                                        marginTop: 1
                                    }}
                                    type="primary"
                                    block
                                >
                                    {IsSpinner ? (
                                        <img
                                            className="processing-spin"
                                            src={icon_processing}
                                        />
                                    ) : (
                                        'SUBMIT'
                                    )}
                                    {/* SUBMIT */}
                                </Button>
                                <Button
                                    onClick={() => navigate('/')}
                                    style={{
                                        // width: 250,
                                        minWidth: 150,
                                        maxWidth: 250,
                                        marginTop: 15,
                                        borderColor: '#578cba',
                                        color: '#578cba'
                                    }}
                                    block
                                >
                                    CANCEL
                                </Button>
                            </Col>
                        </Row>

                        {/* <Row>
                            <Col
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    marginBottom: 21
                                }}
                                span={24}
                            >
                                <Button
                                    onClick={() => {
                                        // props.sendData();
                                        handleClick();
                                    }}
                                    className="blue-button"
                                    style={{
                                        width: 250,
                                        marginTop: props.columnWarning ? 39 : 0
                                    }}
                                    type="primary"
                                    block
                                >
                                    Next
                                </Button>
                                <Button
                                    onClick={() => navigate('/')}
                                    style={{
                                        width: 250,
                                        marginTop: 15,
                                        borderColor: '#578cba',
                                        color: '#578cba'
                                    }}
                                    block
                                >
                                    CANCEL
                                </Button>
                            </Col>
                        </Row> */}
                    </Col>
                </Col>
            </Row>

            <Modal
                className="basic-modal-legal-notice"
                title=""
                visible={showEmptyTablePopup}
                // onOk={changeShowEmptyTablePopup}
                onCancel={changeShowEmptyTablePopup}
                footer={null}
                closable={false}
                bodyStyle={{ minHeight: 280 }}
                width={380}
            >
                <div className="icon-container">
                    {/* <img
                        className="img-icon-container"
                        src={background_circle_red_modal}
                    />
                    <img
                        className="icon-in-green-circle"
                        src={icon_in_red_circle}
                    /> */}
                    <img
                        src={notice}
                        style={{
                            position: 'absolute',
                            top: '-50px',
                            left: '-50px'
                        }}
                    />
                </div>
                <div>
                    <div style={{ padding: '8px 0 0 0', marginLeft: 6 }}>
                        <p
                            className="header-title"
                            style={{ marginBottom: '30px' }}
                        >
                            No Data Found
                        </p>
                        <p
                            style={{
                                fontFamily: 'Roboto Regular',
                                fontSize: '16px',
                                lineHeight: '22px'
                            }}
                        >
                            You need to input data to successfully run analyses.
                            Enter data manually or copy and paste to the
                            spreadsheet.
                        </p>
                    </div>
                    <div
                        style={{
                            textAlign: 'center',
                            marginTop: 95,
                            padding: '0 5px',
                            marginBottom: '6px'
                        }}
                    >
                        <button
                            onClick={() => {
                                changeShowEmptyTablePopup();
                            }}
                            // style={{ width: 223 }}
                            className="ant-btn ant-btn-primary ant-btn-block blue-button"
                        >
                            OK
                        </button>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default ManualData;
